import { useGT } from 'gt-react';
import { Button } from 'src/components/ui/button';
import { bulkApplyToSelectedLinesLabel } from './bulkApplyToSelectedLinesLabel';

export function PolicyOverrideFormActions({
  editing,
  canSubmit,
  pending,
  onSubmit,
  onReset,
  addLabel,
  saveLabel,
  bulkHighlightedCount = 1,
}: {
  editing: boolean;
  canSubmit: boolean;
  pending?: boolean;
  onSubmit: () => void;
  onReset: () => void;
  addLabel: string;
  saveLabel: string;
  bulkHighlightedCount?: number;
}) {
  const gt = useGT();
  const bulk = bulkHighlightedCount > 1 && !editing;
  const label = editing
    ? saveLabel
    : bulk
      ? bulkApplyToSelectedLinesLabel(gt, bulkHighlightedCount)
      : addLabel;

  return (
    <div className="mt-2 flex gap-2">
      <Button
        className="flex-1"
        size="sm"
        disabled={!canSubmit || pending}
        onClick={onSubmit}
      >
        {label}
      </Button>
      {editing ? (
        <Button size="sm" variant="outline" onClick={onReset}>
          {gt('Cancel', { context: 'policy override cancel edit button' })}
        </Button>
      ) : null}
    </div>
  );
}
